<template>
  <component
    :is="rootElement"
    :class="rootFacets"
    :disabled="disabled || null"
    class="export-link btn btn--primary btn--has-grid"
    target="_blank"
  >
    <span class="btn__group-items">
      <span class="btn__group-item">
        <responsive-img
          :class="btnIconFacets"
          :resolutions="[1]"
          :src="img"
          :width="48"
          alt=""
          class="btn__group-item-icon"
        />
      </span>
      <span class="btn__group-item">
        <slot name="default" />
      </span>
    </span>
  </component>
</template>

<script>
  import ResponsiveImg from '@/components/responsive-img/responsive-img'
  import bemMixin from '@/assets/js/mixin/bem'

  export default {
    components: { ResponsiveImg },
    mixins: [bemMixin('export-link')],
    props: {
      disabled: {
        type: Boolean,
        default: false,
      },
      img: {
        type: String,
        required: true,
      },
      size: {
        type: String,
        default: 'medium',
      },
    },
    computed: {
      rootElement() {
        return this.disabled ? 'button' : 'a'
      },
      rootFacets() {
        return [this.bemAdd(this.size)]
      },
      btnIconFacets() {
        return [this.bemAdd(this.size, 'group-item-icon', 'btn')]
      },
    },
  }
</script>

<style lang="scss" src="./_export-link.scss" />
